module.exports = __webpack_public_path__ + "img/Screenshot_2022-03-22_050844-removebg-preview.e164b4a2.png";